import { createFileRoute } from '@tanstack/react-router';
import { EditarFazendaView } from '@/modules/agronomia/components/EditarFazendaView';

// Tela · Editar fazenda — nome/município/UF/tipo, talhões e KML atualizado.
export const Route = createFileRoute('/_authed/agronomia_/fazendas_/$id_/editar')({
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return <EditarFazendaView imovelId={Number(id)} />;
}
